import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
function Termtwo() {
    useEffect(() => {
        document.title = 'Syllabus Term-2 -  St Peters convent School Faridabad Haryana';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li> Academics</li>
                    <li>Syllabus Term-2</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12">
                            <h1 className="fw-bold">Syllabus – Term 2</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">  Secondary Stage</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/SecondarySyllabus.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">Middle Stage</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/MiddleSyllabus.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">Preparatory Stage</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/PreparatorySyllabus.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">Foundational Stage</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/FoundationalSyllabus.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold"> UKG</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ukg.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">  LKG</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/lkg.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card syllabus-card h-100 text-center">
                                <div className="card-body">
                                    <div className="pdf-icon mb-3">📄</div>
                                    <h6 className="fw-semibold">   Nursery</h6>
                                    <a
                                        href="https://webapi.entab.info/api/image/STPSFH/public/pdf/nur.pdf"
                                        target="_blank"
                                        className="click-text"
                                    >
                                        Click Here →
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Termtwo